// extracted by mini-css-extract-plugin
export default {"header":"G5-z","logo":"H5-z","signin":"I5-z"};